import { styled, Chip, Icon, Box, FormControl } from '@mui/material';
import useAnalytics, { eventName } from '@/hooks/use-analytics';

export const BaseChipElement = ({
  onChange,
  options,
  value,
}: {
  onChange: (value: string | number | boolean | null) => void;
  options: { value: string | number | boolean; label: string; icon?: string }[];
  value: string | number | boolean | null;
}) => {
  const { trackClick } = useAnalytics();

  return (
    <FormControl sx={{ display: 'contents' }}>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        {options.map((option) => {
          const selected = value === option.value;
          const icon = selected ? <Icon color='primary'>{option.icon ?? 'check'}</Icon> : undefined;
          return (
            <StyledChip
              key={option.value.toString()}
              icon={icon}
              label={option.label}
              onClick={() => {
                trackClick(eventName(option.label));
                onChange(option.value);
              }}
              size={'small'}
              variant={'outlined'}
              selected={selected}
            />
          );
        })}
      </Box>
    </FormControl>
  );
};

export const StyledChip = styled(Chip)<{
  selected: boolean;
}>`
  min-width: 5ch;
  padding-inline: 1ch;
  gap: 4px;

  &.MuiChip-outlined {
    color: ${({ selected, theme }) => (selected ? theme.palette.text.primary : theme.palette.text.secondary)};
    border: ${({ selected, theme }) =>
      selected ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.border.main}`};
    font-weight: ${({ selected }) => (selected ? '500' : '400')};
    box-shadow: ${({ selected }) => (selected ? 'var(--shadow-small)' : 'none')};
  }

  .MuiTouchRipple-child {
    background-color: var(--mui-palette-primary-main) !important;
  }

  & > .MuiIcon-root {
    font-size: 100%;
  }
`;
